import { FC } from 'react';
import { Route } from 'react-router';
import { createUseStyles } from 'react-jss';
import { IonButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { ActiveCareMapProviderV2 } from '../ActiveCareMapProvider';
import { InnerhivePage } from '../InnerhivePage';
import { CareMapState } from '../caremap/CareMapState';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { ArrowLeftIcon } from '../theme/Icons';
import { Onboarding } from './Onboarding';

// The onboarding checklist used to be the home "Setup" tab. Now that the home page is tabless it lives
// here, reached from the hamburger nav. Home falls back here as the back target.
const HOME_PATH = '/caregiver';

export const OnboardingPageRouteHandler: FC = () => (
    <Route exact path="/setup" render={() => <OnboardingPage />} />
);

const useStyles = createUseStyles({
    content: {
        // skipAddingIonContent means IonContent isn't told the fixed IonHeader's height, so pad past it
        // (otherwise the first content -- the care-recipient switcher -- hides under the header)
        '--padding-top': 'calc(56px + var(--ion-safe-area-top)) !important',
        '--padding-bottom': '24px',
    },
});

export const OnboardingPage: FC = () => {
    const classes = useStyles();

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const history = useInstance(HistoryViewModel);

    const activeCareMapId = careMapState.getMostRecentCaremap()?.careMapId;

    return (
        <ActiveCareMapProviderV2 careMapId={activeCareMapId}>
            <InnerhivePage skipAddingIonContent hideAppHeader>
                <IonContent className={classes.content} data-type="onboarding-page">
                    <IonHeader slot="fixed">
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonButton data-type="back-button" fill="clear" shape="round" onClick={() => history.back({ fallbackPath: HOME_PATH })}>
                                    <ArrowLeftIcon color="dark" />
                                </IonButton>
                            </IonButtons>
                            <IonTitle>Set up</IonTitle>
                        </IonToolbar>
                    </IonHeader>

                    <Onboarding />
                </IonContent>
            </InnerhivePage>
        </ActiveCareMapProviderV2>
    );
};
